import { useMemo } from 'react';

import { useProductLandingContextOptional } from '../contexts/useProductLanding';

export function useProductLandingClickstreamProps() {
  const context = useProductLandingContextOptional();
  const personalizationStatus = context?.personalizationStatus ?? 'disabled';
  const isVeloPersonalizedCopy = context?.isVeloPersonalizedCopy ?? false;

  return useMemo(() => ({
    veloPersonalizedCopy: Boolean(isVeloPersonalizedCopy),
    veloPersonalizationStatus: personalizationStatus
  }), [isVeloPersonalizedCopy, personalizationStatus]);
}
